module.exports = __webpack_public_path__ + "img/loading.dc0bda18.gif";